import React, { Suspense} from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import useToken from './components/App/useToken'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register')) 
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500')) 


export default function App() {
  const {token, getToken, setToken, setRole, setAbility, setBusinessId} = useToken();
  
  if (!token || getToken === null) {
    return (
      <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login setToken={setToken} s/>} />
          <Route exact path="/register/:token" name="Register Page" element={<Register />} />
          <Route path="*" name="Login Page" element={<Login setToken={setToken} setRole={setRole} setAbility={setAbility} setBusinessId={setBusinessId} />} />
        </Routes>
      </Suspense>
    </HashRouter>
    )
  }

  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}